'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_codecs_package$$anon$2(outer) {
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
}
export { $c_Lcom_raquo_laminar_codecs_package$$anon$2 as $c_Lcom_raquo_laminar_codecs_package$$anon$2 };
$p = $c_Lcom_raquo_laminar_codecs_package$$anon$2.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_codecs_package$$anon$2;
/** @constructor */
function $h_Lcom_raquo_laminar_codecs_package$$anon$2() {
}
export { $h_Lcom_raquo_laminar_codecs_package$$anon$2 as $h_Lcom_raquo_laminar_codecs_package$$anon$2 };
$h_Lcom_raquo_laminar_codecs_package$$anon$2.prototype = $p;
$p.ie = (function(scalaValue) {
  return scalaValue;
});
$p.kR = (function(domValue) {
  return domValue;
});
var $d_Lcom_raquo_laminar_codecs_package$$anon$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_codecs_package$$anon$2, "com.raquo.laminar.codecs.package$$anon$2", ({
  hI: 1,
  bb: 1
}));
export { $d_Lcom_raquo_laminar_codecs_package$$anon$2 as $d_Lcom_raquo_laminar_codecs_package$$anon$2 };
